import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Avatar, Button, Divider, Flex, message, Space, Table} from "antd";
import Search from "antd/es/input/Search";
import {arrRemove, globalData, setKey} from "../../util/util";
import List from "antd/es/list";
import Icon from "../Icon";
import {Link, useSearchParams} from "react-router-dom";
import Tag from "antd/es/tag";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import Tooltip from "antd/es/tooltip";
import Radio from "antd/es/radio";
import Svp from "../Svp";
import CloseOutlined from "@ant-design/icons/lib/icons/CloseOutlined";
import RedoOutlined from "@ant-design/icons/lib/icons/RedoOutlined";
import BpSimBpList from "../BpSimBpList";
import ArrowUpOutlined from "@ant-design/icons/lib/icons/ArrowUpOutlined";
import CheckOutlined from "@ant-design/icons/lib/icons/CheckOutlined";
import Rate from "antd/es/rate";
import StopOutlined from "@ant-design/icons/lib/icons/StopOutlined";
import Checkbox from "antd/es/checkbox";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";


let ws = new WebSocket('wss://www.aslucky.club/bpsim')
// let ws
// if (document.location.origin.indexOf('localhost') > -1) {
//     ws = new WebSocket('ws://127.0.0.1:8093/bpsim')
// } else {
//     ws = new WebSocket('wss://103.106.189.20/bpsim')
// }

const typeList = [0,1,2,3,4,5,6]
const typeName = {
    0: 'None',
    1: 'Mage',
    2: 'Marksman',
    3: 'Fighter',
    4: 'Tank',
    5: 'Assassin',
    6: 'Support',
}

export default () => {

    const [searchParams, setSearchParams] = useSearchParams()
    const {t} = useTranslation()
    const [dataIds, setDataIds] = useState([])
    const [stateIds, setStateIds] = useState({})
    const [bpData, setBpData] = useState({
        team1picks: [],
        team2picks: [],
        team1bans: [],
        team2bans: [],
    })

    const [capData, setCapData] = useState({
        team1: null,
        team2: null,
    })

    let [step,setStep] = useState(1)
    let [isNew,setIsNew] = useState(false)
    let [starMap,setStarMap] = useState({})
    let [team,setTeam] = useState(0)
    let [isEditable,setIsEditable] = useState(false)
    let [playerList,setPlayerList] = useState([])

    let teamSelected = {}

    let self = globalData('self')

    let isLocal = searchParams.get("tanji") == 1

    const setAuth = (player, v, type) => {
        if (type === 2) {
            player.writable = v
        }
        if (type === 3) {
            player.readable = v
        }
        setPlayerList([...playerList])
        ws.send(`${type}${JSON.stringify(player)}`)
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (v, p) => <Space>
                {
                    p.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size={40} icon={<UserOutlined />} />
                        : <Avatar shape="square" size={40} icon={<UserOutlined />} />
                }
                <span>{p.clanTag ? `<${p.clanTag}>` : ''}{p.name}</span>
            </Space>,
        },
        {
            title: 'R',
            dataIndex: 'readable',
            key: 'readable',
            render: (v, r) => <Checkbox disabled={self.sign !== '89b9334b'} checked={v} onChange={(e) => { setAuth(r, e.target.checked, 3)} }/>,
            align: 'center'
        },
        {
            title: 'W',
            dataIndex: 'writable',
            key: 'writable',
            render: (v, r) => <Checkbox disabled={self.sign !== '89b9334b'} checked={v} onChange={(e) => { setAuth(r, e.target.checked, 2)} }/>,
            align: 'center'
        },

    ]

    if (!isLocal) {
        ws.onmessage = (e) => {
            if (e.data.length < 5) {
                return
            }
            let obj = JSON.parse(e.data)
            if (obj && typeof obj === 'object') {
                setDataIds(obj.dataIds)
                setStateIds(obj.stateIds)
                setBpData(obj.bpData)
                setCapData(obj.capData)
                setStep(obj.step)
                setStarMap(obj.starMap)
                setIsEditable(obj.isEditable)
                setKey(obj.playerList, 'handle')
                setPlayerList(obj.playerList)

            }
            isNew = true
            setIsNew(isNew)
        }
    }


    const sendData = () => {
        if (isLocal) {
            globalData('bpsim_bak', {
                dataIds,
                stateIds,
                bpData,
                capData,
                step,
                starMap,
                isEditable,
            })
            return;
        }
        if (!isNew) {
           return
        }
        ws.send(JSON.stringify({
            dataIds,
            stateIds,
            bpData,
            capData,
            step,
            starMap,
            isEditable,
        }))
    }

    useEffect(() => {
        if (isLocal) return
        function init() {
            ws.send(`1${JSON.stringify(self)}`)
        }
        if (ws.readyState === 0) {
            ws.onopen = () => {
                init()
            }
        } else {
            init()
        }

        let key = setInterval(() => {
            if (ws.readyState > 1) {
                ws = new WebSocket('wss://www.aslucky.club/bpsim')
                ws.onopen = () => {
                    init()
                }
            } else {
                ws.send('4')
            }
        }, 2000)

        return () => {
            clearInterval(key)
        }

    }, [ws])

    useEffect(() => {
        let bpsim_team = globalData('bpsim_team')
        setTeam(team = bpsim_team ? bpsim_team : 0)
        for (let i = 1; i <= 51; ++i) {
            dataIds.push(i)
            stateIds[i] = {
                type: 0,
                menu: false,
                level: 2,
                ban: false,
                pick: false,
            }
        }
        setDataIds([...dataIds])


        if (isLocal) {
            let obj = globalData('bpsim_bak')
            if (obj && typeof obj === 'object') {
                setDataIds(obj.dataIds)
                setStateIds(obj.stateIds)
                setBpData(obj.bpData)
                setCapData(obj.capData)
                setStep(obj.step)
                setStarMap(obj.starMap)
                setIsEditable(obj.isEditable)

            }
        }
    }, [])

    const reset = () => {
        setStep(1)
        bpData.team1picks = []
        bpData.team2picks = []
        bpData.team1bans = []
        bpData.team2bans = []
        for (const i in stateIds) {
            stateIds[i].pick = false
            stateIds[i].ban = false
        }
        setStateIds({...stateIds})
        sendData()
    }

    const removeHero = (id) => {
        if (!team || !isEditable) return
        let arr = bpData[`team${team}picks`]
        let success = false
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === id) {
                success = true
                arr.splice(i, 1)
                break
            }
        }
        if (success) {
            stateIds[id].pick = false
            setStateIds({...stateIds})
            setBpData({...bpData})
            sendData()
        }
    }

    const onHeroClick = (id) => {

        if (stateIds[id].ban) {
            return
        }

        if (stateIds[id].pick) {
            if (isEditable) {
                removeHero(id)
            }
            return;
        }

        if (isEditable) {
            if (!team) return
            if (bpData[`team${team}picks`].length >= 5) return

            bpData[`team${team}picks`].push(id)
            stateIds[id].pick = true
            setStateIds({...stateIds})
            setBpData({...bpData})

            sendData()
            return
        }

        if (!self || step > 16) return
        let isBanning = false
        let cur = ''
        if (step <= 4 || step === 11 || step === 12) {
            isBanning = true
        }
        if (new Set([1,3,5,8,9,12,14,15]).has(step)) {
            cur = 'team1'
        } else {
            cur = 'team2'
        }
        if (capData[cur] === null || capData[cur].handle !==  self.handle) {
            return
        }

        if (isBanning) {
            bpData[`${cur}bans`].push(id)
            stateIds[id].ban = true
        } else {
            bpData[`${cur}picks`].push(id)
            stateIds[id].pick = true
        }

        setStep(++step)
        setStateIds({...stateIds})
        setBpData({...bpData})

        sendData()
    }

    const asCap = (team) => {
        setTeam(team)
        globalData('bpsim_team', team)
        if (!self) return

        capData[`team${team}`] = self

        setCapData({...capData})

        sendData()
    }

    const getStarNum = (team) => {
        let arr = [...bpData[`team${team}picks`]]
        if (arr.length !== 5) return 0.0
        let num = starMap[arr.sort((a, b) => a - b).join('-')]
        return num ? num : 0.0
    }

    const updateStar0 = (ids, num) => {
        if (starMap[ids] === num) return

        if (num === 0.0) {
            delete starMap[ids]
        } else {
            starMap[ids] = num
        }

        setStarMap({...starMap})
        sendData()
    }

    const updateStar = (team, num) => {
        let arr = [...bpData[`team${team}picks`]]
        if (arr.length !== 5) return

        let ids = arr.sort((a, b) => a - b).join('-');
        updateStar0(ids, num)
    }

    const getCollection = () => {
        teamSelected = {}
        if (team > 0) {
            let arr = [...bpData[`team${team}picks`]]
            for (const id of arr) {
                teamSelected[id] = true
            }
        }

        let list = []
        for (const ids in starMap) {
           list.push({
               star: starMap[ids],
               key: ids,
               ids: ids.split('-').map((a) => Number(a)).sort((a, b) => {
                   if (teamSelected[a] && !teamSelected[b]) return -1
                   if (teamSelected[b] && !teamSelected[a]) return 1
                   let r = stateIds[a].level - stateIds[b].level;
                   return r !== 0 ? r : a - b
               })
           })
        }
        for (const item of list) {
            let selectedNum = 0
            for (const id of item.ids) {
                if (teamSelected[id]) {
                    selectedNum++
                }
            }
            item.selectedNum = selectedNum
        }

        return list.sort((a, b) => {
            let r = b.selectedNum - a.selectedNum
            return r !== 0 ? r : b.star - a.star
        })
    }

    return <div style={{ background: '#f5f5f5', padding: '50px', paddingTop: "100px", minHeight: '900px',height: 'auto', textAlign: 'center'}}> <Space direction={'vertical'}>

        <Table title={() => <strong>Online</strong>} style={{position: 'fixed', top: '200px', right: 0,}} pagination={false} columns={columns} dataSource={playerList} />

        <Space size={50}>
            <div className={'bpSimHeroTable'} style={{height: "170px"}}>
                <Space direction={'vertical'}>
                    <Rate allowHalf value={getStarNum(1)} onChange={(num) => {updateStar(1, num)}} />
                    <Space>
                        <h3>Team 1</h3>
                        {
                            capData.team1 ? <h3>{capData.team1.name}</h3> : null
                        }
                        <Button onClick={() => asCap(1)} icon={<ArrowUpOutlined />}/>
                        <CheckOutlined hidden={team !== 1} height={30} width={30} style={{ color: '#52c41a', fontSize: "30px"}} />
                    </Space>
                    <BpSimBpList data={bpData.team1bans} stateIds={stateIds}/>
                    <BpSimBpList data={bpData.team1picks} stateIds={stateIds} remove={removeHero}/>
                </Space>
            </div>
            <div>
                <Space direction={'vertical'}>
                    <Checkbox checked={isEditable} onChange={(e) => {setIsEditable(isEditable = e.target.checked);sendData()}}><EditOutlined /></Checkbox>
                    <Button onClick={() => reset()} icon=<RedoOutlined /> />
                </Space>
            </div>
            <div className={'bpSimHeroTable'} style={{height: "170px"}}>
                <Space direction={'vertical'}>
                    <Rate allowHalf value={getStarNum(2)} onChange={(num) => {updateStar(2, num)}}/>
                    <Space>
                        <h3>Team 2</h3>
                        {
                            capData.team2 ? <h3>{capData.team2.name}</h3> : null
                        }
                        <Button onClick={() => asCap(2)} icon={<ArrowUpOutlined />}/>
                        <CheckOutlined hidden={team !== 2} height={30} width={30} style={{ color: '#52c41a', fontSize: "30px"}} />
                    </Space>
                    <BpSimBpList data={bpData.team2bans} stateIds={stateIds}/>
                    <BpSimBpList data={bpData.team2picks} stateIds={stateIds} remove={removeHero}/>
                </Space>
            </div>
        </Space>

        <Flex gap="small" vertical>
            {
                typeList.map((type) =>
                    <div style={{ background: '#f0f0f0', width: '770px', padding: '5px'}} key={type} hidden={dataIds.filter((id) => stateIds[id].type === type).length === 0}>
                        <h3>{typeName[type]}</h3>
                        <Flex wrap={'wrap'} className={'bpSimHeroTable'} >
                            {
                                dataIds.filter((id) => stateIds[id].type === type).map((id) =>
                                    <div key={id} className={`bpSimHeroItem${stateIds[id].level}`}>
                                        <Tooltip color={'white'} open={stateIds[id].menu} onOpenChange={(b) => {
                                            stateIds[id].menu = b
                                            setStateIds({...stateIds})
                                        }} trigger={'contextMenu'} placement="right"
                                                 title={
                                                     <Space direction={"vertical"}>
                                                         <Radio.Group onChange={(e) => {
                                                             stateIds[id].level = e.target.value
                                                             stateIds[id].menu = false
                                                             dataIds.sort((a, b) => {
                                                                 let r = stateIds[a].level - stateIds[b].level
                                                                 return r === 0 ? a - b : r
                                                             })
                                                             setStateIds({...stateIds})
                                                             sendData()
                                                         }} value={stateIds[id].level}>
                                                             <Radio value={1}>S</Radio>
                                                             <Radio value={2}>A</Radio>
                                                             <Radio value={3}>D</Radio>
                                                         </Radio.Group>
                                                         <Radio.Group onChange={(e) => {
                                                             stateIds[id].type = e.target.value
                                                             stateIds[id].menu = false
                                                             setStateIds({...stateIds})
                                                             sendData()
                                                         }} value={stateIds[id].type}>
                                                             {typeList.map((type) => <Radio key={type} value={type}>{typeName[type]}</Radio>)}
                                                         </Radio.Group>
                                                     </Space>
                                                 }>
                                            <div onClick={() => {
                                                onHeroClick(id)
                                            }}>
                                                <Icon type={'hero'} name={id} size={50} />
                                                {
                                                    stateIds[id].ban ? <div style={{ position: 'relative' }}>
                                                        <StopOutlined height={50} width={50} style={{ color: '#cf1322', fontSize: "50px", position: "absolute", bottom: 0, left: 0 }} />
                                                    </div> : null
                                                }
                                                {
                                                    stateIds[id].pick ? <div style={{ position: 'relative' }}>
                                                        <CheckOutlined height={50} width={50} style={{ color: '#52c41a', fontSize: "50px", position: "absolute", bottom: 0, left: 0 }} />
                                                    </div> : null
                                                }
                                            </div>
                                        </Tooltip>

                                    </div>



                                )
                            }
                        </Flex>
                    </div>
                )
            }

        </Flex>

        <List
            size="small"
            pagination={ { hideOnSinglePage: true } }
            bordered
            dataSource={getCollection()}
            renderItem={(item) => <List.Item onClick={() => {
                if (!isEditable) return
                bpData[`team${team}picks`].forEach(id => {
                    stateIds[id].pick = false
                })
                bpData[`team${team}picks`] = item.ids
                item.ids.forEach(id => {
                    stateIds[id].pick = true
                })
                setStateIds({...stateIds})
                setBpData({...bpData})
                sendData()
            }}>{

                <Space>
                    <Space>
                        {
                            item.ids.map(id =>
                                <div key={id} className={`bpSimHeroItem${stateIds[id].level}`}>
                                    <Icon type={'hero'} name={id} size={40} />
                                    {
                                        teamSelected[id] ? <div style={{ position: 'relative' }}>
                                            <CheckOutlined height={40} width={40} style={{ color: '#52c41a', fontSize: "40px", position: "absolute", bottom: 0, left: 0 }} />
                                        </div> : null
                                    }
                                </div>
                            )
                        }
                    </Space>
                    <Rate allowHalf value={starMap[item.key]} onChange={(num) => {updateStar0(item.key, num)}} />
                </Space>

            }</List.Item>}
        />

        <Button onClick={() => {
            globalData('bpsim_bak', {
                dataIds,
                stateIds,
                bpData,
                capData,
                step,
                starMap,
                isEditable,
            })
            message.success("SUCCESS").then()
        }}>备份</Button>

    </Space></div>
}
